<script lang="ts">
	import AddressEditBox from './AddressEditBox.svelte';
    import RadioGroup from './RadioGroup.svelte';
    import SkeletonLoader from './SkeletonLoader.svelte';
    import { addressStore } from '../api/address.ts';
    import * as t from '../translations/Address.ts';
    
    export let editingAddress;
    export let selectedAddress;
    export let onSelectAddress;
    export let lockAddress;
    export let isLoading;
    export let addressTypes =['H', 'B'];
    
    export let onClearAddress = () => {};
    
    export let onSelectedAddressTypeChanged = () => {};
    
    let selectedAddressType = 'H';
    
    const allOptions = [{
        value: 'H',
        label: t.HomeAddress(),
        prefix: t.Home()
    }, {
        value: 'B',
        label: t.BusinessAddress(),
        prefix: t.Business()
    }];
    let options;

    function filter(){
       // const newOptions = allOptions.filter((option) => !addressTypes || addressTypes.length === 0 || addressTypes.find((addressType) => addressType === option.value))
        const newOptions = allOptions.filter((option) => addressTypes && addressTypes.find((addressType) => addressType === option.value));
        const optionsHaveChanged = JSON.stringify(options) !== JSON.stringify(newOptions);
        options = newOptions;
        
        if (optionsHaveChanged) {
            selectedAddressType = options && options.length > 0 ? options[0].value : undefined;   
        }
    }
    
    function selectAddressType(address) {
        if (address?.addressType){
            selectedAddressType = address.addressType;
        }
    }
    
    $: filter(addressTypes);
    $: selectAddressType($addressStore.selectedAddress);
    
    $: onSelectedAddressTypeChanged?.(selectedAddressType);
</script>

<div class="p-4 bg-gray-100">
    {#if !(lockAddress || !editingAddress)}
        <h2 class="text-2xl">
            <slot />
        </h2>
    {/if}

    {#if isLoading}
        <SkeletonLoader class="w-[100%]" height="220" />
    {:else}
        {#if options && options.length > 1 && editingAddress}
            <RadioGroup class="mt-4" options={options} bind:userSelected={selectedAddressType}/>
        {/if}
    
        {#each options as { value, label, prefix }}
            <AddressEditBox
                    bind:editingAddress
                    bind:selectedAddress
                    onSelectAddress={onSelectAddress}
                    onClearAddress={onClearAddress}
                    lock={lockAddress}
                    addressType={value}
                    bind:visibleAddressType={selectedAddressType}
                    prefix={prefix}
            >
            </AddressEditBox>
        {/each}

    {/if}
</div>